import { useCallback } from 'react';

import { Radio, StyledFlex } from '@dreryk/react-components';

import { prescriptionTranslationKeys } from '../../../../../../../translations';
import { DosageCycleClass } from '../../extendedDosage.utils';

type StageModeRadioGroupProps = {
   readonly index: number;
   readonly mode: DosageCycleClass;
   readonly onChangeStageMode: (index: number, mode: DosageCycleClass) => void;
};

export const StageModeRadioGroup = (props: StageModeRadioGroupProps): JSX.Element => {
   const handleFrequency = useCallback(
      () => props.onChangeStageMode(props.index, 'FrequencyDosageCycle'),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [props.onChangeStageMode, props.index]
   );
   const handleTimesOfDay = useCallback(
      () => props.onChangeStageMode(props.index, 'TimesOfDayDosageCycle'),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [props.onChangeStageMode, props.index]
   );

   return (
      <StyledFlex gap={'16px'} alignItems={'center'}>
         <Radio
            testId={`modeFrequency-${props.index}`}
            name={`stageMode-${props.index}`}
            value={'FrequencyDosageCycle'}
            label={prescriptionTranslationKeys.extendedDosage.stageModeFrequency}
            selected={props.mode === 'FrequencyDosageCycle'}
            onChange={handleFrequency}
         />
         <Radio
            testId={`modeTimesOfDay-${props.index}`}
            name={`stageMode-${props.index}`}
            value={'TimesOfDayDosageCycle'}
            label={prescriptionTranslationKeys.extendedDosage.stageModeTimesOfDay}
            selected={props.mode === 'TimesOfDayDosageCycle'}
            onChange={handleTimesOfDay}
         />
      </StyledFlex>
   );
};
